export function isSizeLarge(size) {
  return size === 'large' || size === 'lg';
}
export function isSizeSmall(size) {
  return size === 'small' || size === 'sm';
}